// extracted by mini-css-extract-plugin
module.exports =  {"container":"TSSSyNb","lohp-test":"h4B_St5","lohpTest":"h4B_St5","placeholder":"qJOSo4P","title":"V5QxxDS"};